var map = {
	"./Archer.png": 8318,
	"./Bear.png": 5233,
	"./Hellhound.png": 4394,
	"./Javelinier.png": 3388,
	"./Lancer.png": 1430,
	"./Magi.png": 6861,
	"./OakTreant.png": 5090,
	"./Outlaw.png": 4063,
	"./Overseer.png": 1140,
	"./Paladin.png": 358,
	"./Priest.png": 3622,
	"./Rogue.png": 3477,
	"./Sellsword.png": 7020,
	"./Soldier.png": 485,
	"./Sorcerer.png": 9548,
	"./Surge.png": 8921,
	"./Treant.png": 1529,
	"./Warrior.png": 4981,
	"./Witch.png": 402,
	"./Wolf.png": 9699,
	"./Zealot.png": 9686
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3529;